import * as s from "../styles";

// 진도관리 캐러셀 card
function Progress({ data }) {
  return <s.Container>진도관리 바깥부분</s.Container>;
}

export default Progress;
